<template>
    <div :class="[
        'course__show_links',
        mainBoxActive ? 'course__show_links--opened' : ''
    ]">
        <div class="course__show_links_header">
            <div class="columns is-vcentered is-variable is-2">
                <div class="column is-narrow">
                    <component-title
                        :size="'small'"
                        :raw="true"
                    >Useful links
                    </component-title>
                </div>
                <div class="column"></div>
                <div class="column is-narrow">
                    <component-button
                        :name="'course-show-links-expand'"
                        :icon="true"
                        :icon-name="mainBoxActive ? 'chevron-up' : 'chevron-down'"
                        :icon-raw="true"
                        :theme="''"
                        @click="switchMainBox"
                    ></component-button>
                </div>
            </div>
        </div>
        <template v-if="mainBoxActive">
            <div class="course__show_links_main">
                <div class="course__show_links_main_list">
                    <template v-for="(link, index) in linksOutput">
                        <div
                            :key="index"
                            class="course__show_links_main_list_item"
                        >
                            <div class="columns is-vcentered">
                                <div class="column">
                                    <template v-if="link.visibility === 'all' || link.visibility === 'enrolled' && allowDisplay">
                                        <a
                                            :class="'course__show_links_main_list_item_link'"
                                            :name="'course-show-links-main-list-item-link'"
                                            :href="(!link.url.includes('http') ? '//' : '') + link.url"
                                            target="_blank"
                                            @click.prevent="handleRedirect"
                                        >{{ link.text }}</a>
                                    </template>
                                    <template v-else-if="link.visibility === 'enrolled' && !allowDisplay">
                                        <div class="course__show_links_main_list_item_name">{{ link.text }}</div>
                                        <div class="course__show_links_main_list_item_explanation">Enrol to open link</div>
                                    </template>
                                </div>
                            </div>
                        </div>
                    </template>
                </div>
            </div>
        </template>
        <pop-notify
            :title-text="'External link'"
            :content-text="'This link leads to external website. Do you want to proceed?'"
            :cancel-button-text="'Cancel'"
            :submit-button-text="'Confirm'"
            ref="externallinknotify"
            @emit-submit="performRedirect"
        />
    </div>
</template>

<script>
import ComponentTitle from '@/components/default/shared/ComponentTitle'
import ComponentButton from '@/components/default/shared/ComponentButton'
import PopNotify from '@/components/default/shared/PopNotify'
import { User } from '@/User'

export default {
  name: 'course-show-links',
  components: { PopNotify, ComponentButton, ComponentTitle },
  data () {
    return {
      mainBoxActive: false,
      user: new User()
    }
  },
  props: {
    links: {
      type: Array,
      default: () => []
    },
    allowDisplay: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    linksOutput () {
      const links = this.links

      return links.filter(obj => obj.visibility !== 'none')
    }
  },
  methods: {
    switchMainBox () {
      this.mainBoxActive = !this.mainBoxActive
    },
    performRedirect (data) {
      window.open(data || this.$refs.externallinknotify.storeValue, '_blank')
    },
    handleRedirect (event) {
      const targetHref = event.target.href
      const targetHost = event.target.host
      const locationHost = window.location.host

      if (targetHost !== locationHost) {
        this.$refs.externallinknotify.openNotify()
        this.$refs.externallinknotify.setStoreValue(targetHref)
      } else {
        this.performRedirect(targetHref)
      }
    }
  }
}
</script>

<style lang="scss">
    @import "~@/assets/scss/components/ebs/courses/courseshowlinks";
</style>
